exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-neg-5[data-v-bfabf876]{margin-top:-.9375rem;margin-bottom:-.9375rem}.canvas[data-v-bfabf876]{border:1px solid #ccc;position:relative}.vdr[data-v-bfabf876]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:move;background:rgba(0,0,0,.1)}.templatearea-title[data-v-bfabf876]{font-family:Courier New,Courier,monospace;font-weight:700}.handle[data-v-bfabf876]{border:1px solid #aaa!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bfabf876","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/admin/templates/form.vue
// module id = QkCQ
// module chunks = 1